function long2day(time) {
    if (!time) {
        return ""
    }
    let date = new Date(time);
    let info = "";

    info += date.getFullYear() + ".";

    if ((date.getMonth() + 1) < 10) {
        info += "0" +(date.getMonth() + 1 ) + ".";
    }
    else {
        info += "" +(date.getMonth() + 1 ) + ".";
    }

    if (date.getDate() < 10) {
        info += "0" +(date.getDate()) + "";
    }
    else {
        info += "" +(date.getDate()) + "";
    }

    return info;
}

function long2second(time) {
    if (!time) {
        return ""
    }
    let date = new Date(time);
    let info = "";

    info += date.getFullYear() + ".";

    if ((date.getMonth() + 1) < 10) {
        info += "0" +(date.getMonth() + 1 ) + ".";
    }
    else {
        info += "" +(date.getMonth() + 1 ) + ".";
    }

    if (date.getDate() < 10) {
        info += "0" +(date.getDate()) + " ";
    }
    else {
        info += "" +(date.getDate()) + " ";
    }

    if (date.getHours() < 10) {
        info += "0" +(date.getHours() ) + ":";
    }
    else {
        info += "" +(date.getHours()) + ":";
    }

    if (date.getMinutes() < 10) {
        info += "0" +(date.getMinutes() ) + ":";
    }
    else {
        info += "" +(date.getMinutes() ) + ":";
    }

    if (date.getSeconds() < 10) {
        info += "0" +(date.getSeconds() ) + "";
    }
    else {
        info += "" +(date.getSeconds()  ) + "";
    }

    return info;
}

function long2IntervalDay(startTime, endTime) {
    return long2day(startTime) + "-" + long2day(endTime);
}

export default {
    long2day,
    long2IntervalDay,
    long2second
}
